/**
 * @generated SignedSource<<b8d17b7c2543a75259a06d098a22c766>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type useHardwareDetailRelayQuery$variables = {
  id: string;
};
export type useHardwareDetailRelayQuery$data = {
  readonly getHardware: {
    readonly activeRental: {
      readonly id: string;
      readonly oldId: string | null | undefined;
      readonly startTime: any | null | undefined;
      readonly userId: string | null | undefined;
    } | null | undefined;
    readonly activeRentalId: string | null | undefined;
    readonly batteryPercent: number | null | undefined;
    readonly batteryVoltage: number | null | undefined;
    readonly charging: boolean | null | undefined;
    readonly childHardwareAssignments: ReadonlyArray<{
      readonly child: {
        readonly hardwareProduct: {
          readonly primaryIdentifier: string | null | undefined;
        } | null | undefined;
        readonly hardwareType: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly imei: string | null | undefined;
        readonly label: string | null | undefined;
        readonly mac: string | null | undefined;
        readonly number: number | null | undefined;
        readonly oldId: string | null | undefined;
        readonly state: number | null | undefined;
        readonly vendorId: string | null | undefined;
        readonly vendorSerial: string | null | undefined;
      } | null | undefined;
      readonly createdOn: any;
      readonly hardwareChildId: string | null | undefined;
      readonly hardwareParentId: string | null | undefined;
      readonly id: string;
      readonly removedOn: any | null | undefined;
    }>;
    readonly createdOn: any;
    readonly firmwareVersion: string | null | undefined;
    readonly hardwareProduct: {
      readonly hasBatteryStatus: boolean | null | undefined;
      readonly hasImei: boolean | null | undefined;
      readonly hasLocationTracking: boolean | null | undefined;
      readonly hasMac: boolean | null | undefined;
      readonly hasNumber: boolean | null | undefined;
      readonly hasTcpConnection: boolean | null | undefined;
      readonly hasVendorId: boolean | null | undefined;
      readonly hasVendorSerial: boolean | null | undefined;
      readonly id: string;
      readonly latestFirmwareVersion: string | null | undefined;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
      readonly primaryIdentifier: string | null | undefined;
      readonly supportsBleUnlock: boolean | null | undefined;
      readonly supportsRemoteBatteryLock: boolean | null | undefined;
      readonly supportsRemoteBatteryStatus: boolean | null | undefined;
      readonly supportsRemoteBatteryUnlock: boolean | null | undefined;
      readonly supportsRemoteLocationCheck: boolean | null | undefined;
      readonly supportsRemoteRing: boolean | null | undefined;
      readonly supportsRemoteUnlock: boolean | null | undefined;
      readonly vendor: string | null | undefined;
      readonly vendorSerialDescription: string | null | undefined;
    } | null | undefined;
    readonly hardwareProductId: string;
    readonly hardwareProductOldId: string;
    readonly hardwareProductVersion: {
      readonly id: string;
      readonly name: string | null | undefined;
      readonly oldId: string | null | undefined;
    } | null | undefined;
    readonly hardwareProductVersionId: string | null | undefined;
    readonly hardwareProductVersionOldId: string | null | undefined;
    readonly hardwareType: {
      readonly id: string;
      readonly name: string | null | undefined;
    } | null | undefined;
    readonly hasLatestFirmwareVersion: boolean | null | undefined;
    readonly hasLowBattery: boolean | null | undefined;
    readonly hasOpenSafetyTicket: boolean | null | undefined;
    readonly iccid: string | null | undefined;
    readonly id: string;
    readonly imei: string | null | undefined;
    readonly isActive: boolean | null | undefined;
    readonly isAvailable: boolean | null | undefined;
    readonly isConnected: boolean | null | undefined;
    readonly isInRental: boolean | null | undefined;
    readonly isOnline: boolean | null | undefined;
    readonly isUnlocked: boolean | null | undefined;
    readonly label: string | null | undefined;
    readonly lastSeen: any | null | undefined;
    readonly lat: number | null | undefined;
    readonly lng: number | null | undefined;
    readonly location: {
      readonly id: string;
      readonly name: string;
    } | null | undefined;
    readonly locationId: string | null | undefined;
    readonly locationOldId: string | null | undefined;
    readonly mac: string | null | undefined;
    readonly maintenanceUsageStatus: {
      readonly current: number;
      readonly threshold: number;
      readonly ticketCreatedOn: any | null | undefined;
      readonly ticketId: string | null | undefined;
    } | null | undefined;
    readonly number: number | null | undefined;
    readonly oldId: string | null | undefined;
    readonly openMaintenanceTickets: number;
    readonly organizationId: string | null | undefined;
    readonly overdueMaintenanceTickets: number;
    readonly parentHardwareAssignments: ReadonlyArray<{
      readonly createdOn: any;
      readonly hardwareChildId: string | null | undefined;
      readonly hardwareParentId: string | null | undefined;
      readonly id: string;
      readonly parent: {
        readonly hardwareProduct: {
          readonly primaryIdentifier: string | null | undefined;
        } | null | undefined;
        readonly hardwareType: {
          readonly id: string;
          readonly name: string | null | undefined;
        } | null | undefined;
        readonly id: string;
        readonly imei: string | null | undefined;
        readonly label: string | null | undefined;
        readonly mac: string | null | undefined;
        readonly number: number | null | undefined;
        readonly oldId: string | null | undefined;
        readonly state: number | null | undefined;
        readonly vendorId: string | null | undefined;
        readonly vendorSerial: string | null | undefined;
      } | null | undefined;
      readonly removedOn: any | null | undefined;
    }>;
    readonly qrCode: {
      readonly id: string;
    } | null | undefined;
    readonly rentalCount: number;
    readonly state: number | null | undefined;
    readonly systemId: string | null | undefined;
    readonly systemOldId: string | null | undefined;
    readonly unavailabilityReasons: any | null | undefined;
    readonly vendorId: string | null | undefined;
    readonly vendorQrCode: string | null | undefined;
    readonly vendorSerial: string | null | undefined;
  } | null | undefined;
};
export type useHardwareDetailRelayQuery = {
  response: useHardwareDetailRelayQuery$data;
  variables: useHardwareDetailRelayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "id"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "oldId",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "mac",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "imei",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "iccid",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "label",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "number",
  "storageKey": null
},
v9 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "state",
  "storageKey": null
},
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "batteryPercent",
  "storageKey": null
},
v11 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "batteryVoltage",
  "storageKey": null
},
v12 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "charging",
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "firmwareVersion",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLatestFirmwareVersion",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lat",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lng",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastSeen",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isAvailable",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isConnected",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isUnlocked",
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "activeRentalId",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationId",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "locationOldId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdOn",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vendorId",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vendorQrCode",
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "vendorSerial",
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hardwareProductId",
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hardwareProductOldId",
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hardwareProductVersionId",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hardwareProductVersionOldId",
  "storageKey": null
},
v32 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemId",
  "storageKey": null
},
v34 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "systemOldId",
  "storageKey": null
},
v35 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasLowBattery",
  "storageKey": null
},
v36 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hasOpenSafetyTicket",
  "storageKey": null
},
v37 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isActive",
  "storageKey": null
},
v38 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isInRental",
  "storageKey": null
},
v39 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isOnline",
  "storageKey": null
},
v40 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "openMaintenanceTickets",
  "storageKey": null
},
v41 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "overdueMaintenanceTickets",
  "storageKey": null
},
v42 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "rentalCount",
  "storageKey": null
},
v43 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "unavailabilityReasons",
  "storageKey": null
},
v44 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v45 = [
  (v2/*: any*/),
  (v44/*: any*/)
],
v46 = {
  "alias": null,
  "args": null,
  "concreteType": "HardwareType",
  "kind": "LinkedField",
  "name": "hardwareType",
  "plural": false,
  "selections": (v45/*: any*/),
  "storageKey": null
},
v47 = {
  "alias": null,
  "args": null,
  "concreteType": "Location",
  "kind": "LinkedField",
  "name": "location",
  "plural": false,
  "selections": (v45/*: any*/),
  "storageKey": null
},
v48 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "primaryIdentifier",
  "storageKey": null
},
v49 = {
  "alias": null,
  "args": null,
  "concreteType": "HardwareProduct",
  "kind": "LinkedField",
  "name": "hardwareProduct",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v44/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasMac",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasImei",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasBatteryStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasLocationTracking",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasTcpConnection",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVendorId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasVendorSerial",
      "storageKey": null
    },
    (v48/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsBleUnlock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsRemoteBatteryLock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsRemoteBatteryStatus",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsRemoteBatteryUnlock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsRemoteLocationCheck",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsRemoteRing",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supportsRemoteUnlock",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vendor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "vendorSerialDescription",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "latestFirmwareVersion",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v50 = {
  "alias": null,
  "args": null,
  "concreteType": "HardwareProductVersion",
  "kind": "LinkedField",
  "name": "hardwareProductVersion",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    (v44/*: any*/)
  ],
  "storageKey": null
},
v51 = {
  "alias": null,
  "args": null,
  "concreteType": "Rental",
  "kind": "LinkedField",
  "name": "activeRental",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    (v3/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "startTime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "userId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v52 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "removedOn",
  "storageKey": null
},
v53 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hardwareChildId",
  "storageKey": null
},
v54 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "hardwareParentId",
  "storageKey": null
},
v55 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v8/*: any*/),
  (v7/*: any*/),
  (v9/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v25/*: any*/),
  (v27/*: any*/),
  (v46/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "HardwareProduct",
    "kind": "LinkedField",
    "name": "hardwareProduct",
    "plural": false,
    "selections": [
      (v48/*: any*/)
    ],
    "storageKey": null
  }
],
v56 = {
  "alias": null,
  "args": null,
  "concreteType": "QrCode",
  "kind": "LinkedField",
  "name": "qrCode",
  "plural": false,
  "selections": [
    (v2/*: any*/)
  ],
  "storageKey": null
},
v57 = {
  "alias": null,
  "args": null,
  "concreteType": "HardwareUsageStatus",
  "kind": "LinkedField",
  "name": "maintenanceUsageStatus",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "current",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "threshold",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ticketId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ticketCreatedOn",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v58 = [
  (v2/*: any*/),
  (v3/*: any*/),
  (v8/*: any*/),
  (v7/*: any*/),
  (v9/*: any*/),
  (v4/*: any*/),
  (v5/*: any*/),
  (v25/*: any*/),
  (v27/*: any*/),
  (v46/*: any*/),
  {
    "alias": null,
    "args": null,
    "concreteType": "HardwareProduct",
    "kind": "LinkedField",
    "name": "hardwareProduct",
    "plural": false,
    "selections": [
      (v48/*: any*/),
      (v2/*: any*/)
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useHardwareDetailRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Hardware",
        "kind": "LinkedField",
        "name": "getHardware",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareAssignment",
            "kind": "LinkedField",
            "name": "parentHardwareAssignments",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v24/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Hardware",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": (v55/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v56/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareAssignment",
            "kind": "LinkedField",
            "name": "childHardwareAssignments",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v24/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Hardware",
                "kind": "LinkedField",
                "name": "child",
                "plural": false,
                "selections": (v55/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v57/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useHardwareDetailRelayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Hardware",
        "kind": "LinkedField",
        "name": "getHardware",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          (v3/*: any*/),
          (v4/*: any*/),
          (v5/*: any*/),
          (v6/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          (v10/*: any*/),
          (v11/*: any*/),
          (v12/*: any*/),
          (v13/*: any*/),
          (v14/*: any*/),
          (v15/*: any*/),
          (v16/*: any*/),
          (v17/*: any*/),
          (v18/*: any*/),
          (v19/*: any*/),
          (v20/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v30/*: any*/),
          (v31/*: any*/),
          (v32/*: any*/),
          (v33/*: any*/),
          (v34/*: any*/),
          (v35/*: any*/),
          (v36/*: any*/),
          (v37/*: any*/),
          (v38/*: any*/),
          (v39/*: any*/),
          (v40/*: any*/),
          (v41/*: any*/),
          (v42/*: any*/),
          (v43/*: any*/),
          (v46/*: any*/),
          (v47/*: any*/),
          (v49/*: any*/),
          (v50/*: any*/),
          (v51/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareAssignment",
            "kind": "LinkedField",
            "name": "parentHardwareAssignments",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v24/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Hardware",
                "kind": "LinkedField",
                "name": "parent",
                "plural": false,
                "selections": (v58/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v56/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "HardwareAssignment",
            "kind": "LinkedField",
            "name": "childHardwareAssignments",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v24/*: any*/),
              (v52/*: any*/),
              (v53/*: any*/),
              (v54/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Hardware",
                "kind": "LinkedField",
                "name": "child",
                "plural": false,
                "selections": (v58/*: any*/),
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          (v57/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6cd6bdf19d8cc5b2bcba6c849ad8f53c",
    "id": null,
    "metadata": {},
    "name": "useHardwareDetailRelayQuery",
    "operationKind": "query",
    "text": "query useHardwareDetailRelayQuery(\n  $id: ID!\n) {\n  getHardware(id: $id) {\n    id\n    oldId\n    mac\n    imei\n    iccid\n    label\n    number\n    state\n    batteryPercent\n    batteryVoltage\n    charging\n    firmwareVersion\n    hasLatestFirmwareVersion\n    lat\n    lng\n    lastSeen\n    isAvailable\n    isConnected\n    isUnlocked\n    activeRentalId\n    locationId\n    locationOldId\n    createdOn\n    vendorId\n    vendorQrCode\n    vendorSerial\n    hardwareProductId\n    hardwareProductOldId\n    hardwareProductVersionId\n    hardwareProductVersionOldId\n    organizationId\n    systemId\n    systemOldId\n    hasLowBattery\n    hasOpenSafetyTicket\n    isActive\n    isInRental\n    isOnline\n    openMaintenanceTickets\n    overdueMaintenanceTickets\n    rentalCount\n    unavailabilityReasons\n    hardwareType {\n      id\n      name\n    }\n    location {\n      id\n      name\n    }\n    hardwareProduct {\n      id\n      oldId\n      name\n      hasMac\n      hasImei\n      hasBatteryStatus\n      hasLocationTracking\n      hasNumber\n      hasTcpConnection\n      hasVendorId\n      hasVendorSerial\n      primaryIdentifier\n      supportsBleUnlock\n      supportsRemoteBatteryLock\n      supportsRemoteBatteryStatus\n      supportsRemoteBatteryUnlock\n      supportsRemoteLocationCheck\n      supportsRemoteRing\n      supportsRemoteUnlock\n      vendor\n      vendorSerialDescription\n      latestFirmwareVersion\n    }\n    hardwareProductVersion {\n      id\n      oldId\n      name\n    }\n    activeRental {\n      id\n      oldId\n      startTime\n      userId\n    }\n    parentHardwareAssignments {\n      id\n      createdOn\n      removedOn\n      hardwareChildId\n      hardwareParentId\n      parent {\n        id\n        oldId\n        number\n        label\n        state\n        mac\n        imei\n        vendorId\n        vendorSerial\n        hardwareType {\n          id\n          name\n        }\n        hardwareProduct {\n          primaryIdentifier\n          id\n        }\n      }\n    }\n    qrCode {\n      id\n    }\n    childHardwareAssignments {\n      id\n      createdOn\n      removedOn\n      hardwareChildId\n      hardwareParentId\n      child {\n        id\n        oldId\n        number\n        label\n        state\n        mac\n        imei\n        vendorId\n        vendorSerial\n        hardwareType {\n          id\n          name\n        }\n        hardwareProduct {\n          primaryIdentifier\n          id\n        }\n      }\n    }\n    maintenanceUsageStatus {\n      current\n      threshold\n      ticketId\n      ticketCreatedOn\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "27a8497a006c7a3345e0a4bbd7dcc7ab";

export default node;
